import React, { useEffect, useState } from 'react';
import styles from './counter.module.css';

interface ICounterProps {
  value?: number;
  setValue?: (val: number) => void;
  maxLimit?: number;
  wrapperClassName?: string;
  feature?: string;
  eventClickEmarsys?: (buttonName: string) => void;
}

const Counter = ({
  maxLimit = 99,
  wrapperClassName,
  value,
  setValue,
  feature = '',
  eventClickEmarsys,
}: ICounterProps) => {
  const [isDisabledDecrement, setIsDisabledDecrement] = useState(false);
  const [isDisabledIncrement, setIsDisabledIncrement] = useState(false);

  const incrementCounter = () => {
    if (feature === 'ACCESSORIES' && eventClickEmarsys) {
      eventClickEmarsys('increase quantity');
    }
    setValue(value + 1);
  };

  const decrementCounter = () => {
    if (feature === 'ACCESSORIES' && eventClickEmarsys) {
      eventClickEmarsys('decrease quantity');
    }
    if (value !== 1) {
      setValue(value - 1);
    }
  };

  useEffect(() => {
    if (value === maxLimit) {
      setIsDisabledIncrement(true);
      setIsDisabledDecrement(false);
    } else if (value === 1) {
      setIsDisabledDecrement(true);
      setIsDisabledIncrement(false);
    } else {
      setIsDisabledIncrement(false);
      setIsDisabledDecrement(false);
    }
  }, [value]);

  return (
    <div className={`${styles.customNumberInput} h-[34px] w-32 ${wrapperClassName}`}>
      <div className="flex flex-row justify-end h-[34px] w-full rounded-lg relative bg-transparent mt-1">
        <button
          onClick={decrementCounter}
          className={`${isDisabledDecrement ? ' text-gray-400 border-gray-400' : 'bg-white text-[#CE181E]  border-[#CE181E]'} border  h-full w-[34px] rounded cursor-pointer outline-none`}
          disabled={isDisabledDecrement}
        >
          <span className="m-auto text-2xl leading-7">−</span>
        </button>
        <div className="justify-center outline-none focus:outline-none text-center w-full max-w-[34px] font-semibold text-md md:text-basecursor-default flex items-center text-[#231F20]">
          {value}
        </div>
        <button
          onClick={incrementCounter}
          className={`${isDisabledIncrement ? ' border-gray-400 bg-gray-400' : 'bg-[#CE181E] '} border text-white  h-full w-[34px] rounded cursor-pointer`}
          disabled={isDisabledIncrement}
        >
          <span className="m-auto text-2xl leading-7">+</span>
        </button>
      </div>
    </div>
  );
};

export default Counter;
